export default __webpack_public_path__ + "static/media/vpn-gateway.7908d5f8.svg";